export default function NotFound(): JSX.Element {
	return <div>NotFound</div>;
}
